/**
 * Résout un fichier vidéo local en URL servie par Vite, à partir d'un chemin
 * relatif au dossier `assets/` (ex. 'projects/monde-glace/rafaello/reels/reel-1.mp4').
 *
 * Même principe que `covers.ts` mais pour les vidéos : Vite renvoie une URL
 * hashée et auto-hébergée (pas de lien Instagram qui expire).
 */
const modules = import.meta.glob<string>('../assets/**/*.{mp4,MP4,mov,MOV,webm,WEBM}', {
  eager: true,
  query: '?url',
  import: 'default',
});

const map: Record<string, string> = {};
for (const [key, value] of Object.entries(modules)) {
  const normalized = key.replace(/^\.\.\/assets\//, '');
  map[normalized] = value;
}

export function getVideo(assetPath: string | undefined): string | undefined {
  if (!assetPath) return undefined;
  return map[assetPath];
}
